module.exports = __webpack_public_path__ + "static/img/333328162818199782.49fb3f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/333328162818199782.png
// module id = HGJz
// module chunks = 1